//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services

//components
import adminNav from "emun.admin/admin-nav";

//directives
// import custList from "emun.admin/admin-list";

//states
// import custStates from "emun.admin/admin.states";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

export const services = {};

export const components = {
  adminNav,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  // states: custStates(),
};
